import { render, staticRenderFns } from "./ReportSortingModal.vue?vue&type=template&id=1323b40c"
import script from "./ReportSortingModal.vue?vue&type=script&lang=js"
export * from "./ReportSortingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports